import {useStateIfMounted} from "use-state-if-mounted";
import React, {useMemo, useEffect} from "react";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import Table from "components/Table";
import Icons from "components/Icons";
import Input from "components/Input";
import functions from "functions";
import axios from "axios";

function AllIcons() {
	const [hiddenColumns, setHiddenColumns] = useStateIfMounted(["expander"]);
	const [windowWidth, setWindowWidth] = useStateIfMounted(window.innerWidth);
	let language = useSelector(state => state.Language.language);
	const [control, setControl] = useStateIfMounted(true);
	let type = useSelector(state => state.Session.type);
	const [icons, setIcons] = useStateIfMounted([]);
	useEffect(() => {
		async function icons() {
			let response = await axios.get(`${process.env.REACT_APP_API_URL}/api/list/buttons`);
			setIcons(response.data.result)
		}

		void icons()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	useEffect(() => {
		setWindowWidth(window.innerWidth)
		if (windowWidth < 1140) {
			if (control === true) {
				if (hiddenColumns.length === 1) {
					setHiddenColumns(["email", "type", "card_limit", "islemler"])
				}
				setControl(false)
			}
		} else {
			if (hiddenColumns.length > 1 && control === false) {
				setHiddenColumns(["expander"])
			}
			setControl(true)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [windowWidth])
	window.addEventListener("resize", () => {
		setWindowWidth(window.innerWidth)
	})
	const initialState = {
		sortBy: [],
		hiddenColumns: hiddenColumns,
		pageSize: 20
	}

	async function search() {
		let searchValue = document?.querySelector("input[name=search]")?.value
		let response = await axios.post(`${process.env.REACT_APP_API_URL}/api/list/buttons`, `search=${searchValue}`)
		setIcons(response.data.result)
	}

	const columns = useMemo(
		() => [
			{
				Header: "I/O",
				id: 'expander',
				disableSortBy: true,
				type: "1,2",
				Cell: ({row}) => (
					<i className="noSelect" {...row.getToggleRowExpandedProps()}>{row.isExpanded ? <Icons name="GrClose"/> : <Icons name="GiHamburgerMenu"/>}</i>
				),
				width: 50
			},
			{
				Header: language["table_icon"] ?? "",
				disableSortBy: true,
				id: 'icon_svg',
				type: "1,2",
				width: 40,
				accessor: data => <span style={{backgroundColor: data.bg_color, color: data.color}}><Icons name={data.value}/></span>
			},
			{
				Header: language["table_icon_name"] ?? "",
				id: 'icon_name',
				type: "1,2",
				accessor: data => data.label
			},
			{
				Header: language["table_icon_code"] ?? "",
				disableSortBy: true,
				id: 'icon_code',
				type: "1,2",
				accessor: data => data.value
			},
			{
				Header: language["table_actions"] ?? "",
				id: 'islemler',
				type: "1,2",
				accessor: data => (
					<div className="islemler">
						{
							type >= 1 &&
							<>
								<button className="sil"
										onClick={() => functions.yesno(data.id, language["icon_delete_menu_title"], language["icon_delete_menu_text"], "delete", "icon", search, language)}
										data-tip={language["data_tip_delete"]}><Icons name="BiTrashAlt"/></button>
								<Link className="duzenle" to={`/panel/edit/icon/${data.id}`} data-tip={language["data_tip_edit"]}><Icons name="BiEditAlt"/></Link>
							</>
						}
					</div>
				)
			}
		],
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[language]
	);

	return (
		<div>
			<div className="panelTitle">{language["icons_page_title"]}</div>
			<div className="wrapper">
				<Input type="text" name="search" icon="AiOutlineSearch" value="" title={language["icon_search_input_title"]} col={12} onchange={(value) => search(value)} placeholder={language["among_result"]?.replace("%r", icons.length)}/>
				<Table columns={columns} data={icons} hiddenColumns={hiddenColumns} initialState={initialState}/>
			</div>
		</div>
	)
}

export default AllIcons;